const scrollAnimation = ref(true);

export default () => {
  return scrollAnimation;
};
